import { render, staticRenderFns } from "./DemoParameterComparisonChart.vue?vue&type=template&id=228990b8&scoped=true&"
import script from "./DemoParameterComparisonChart.vue?vue&type=script&lang=js&"
export * from "./DemoParameterComparisonChart.vue?vue&type=script&lang=js&"
import style0 from "./DemoParameterComparisonChart.vue?vue&type=style&index=0&id=228990b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228990b8",
  null
  
)

export default component.exports